module.exports = __webpack_public_path__ + "static/media/studentNameIcon.bf897f6a.svg";